import React, { useEffect, useState } from 'react';
import { CircularProgressCustom } from "./common-components/CircularProgressCustom";
import { useQuery } from "@apollo/react-hooks";
import { apiUrl } from "./../../services/constants";
import { GET_CATEGORIES, GET_TOTAL_PRODUCTS, GET_COLLECTIONS_RELATE, GET_TOTAL_COLLECTIONS } from "./../../services/graphql-query";
import { useNavigate } from 'react-router-dom';
import { Breadcrumb, Row, Col, Container, Tab, Tabs } from 'react-bootstrap';
import { BsArrowRight } from 'react-icons/bs';
import Carousel from "react-elastic-carousel";

// component
import Resource from './productdetail/resource';
import OrderGuide from './productdetail/OrderGuide';
import Distribution from './productdetail/Distribution';
import Certifications from './productdetail/Certifications';
import Accessories from './productdetail/Accessories';

// icons
import output from '../assets/icons/Output.svg';
import efficacy from '../assets/icons/Efficacy.svg';
import ccts from '../assets/icons/CCTs.svg';
import temperature from '../assets/icons/Temp.svg';
import warranty from '../assets/icons/Warranty.svg';
import menudots from '../assets/images/menu_dot.svg';

// images
import slider from '../assets/images/SLIDER.png';

// css
import '../../css/app.css';

const Tab_List = [
    "Resources & Downloads", "Distribution", "Certifications", "Accessories"
]

const ProductDetail = () => {
    const navigate = useNavigate();

    const [category, setCategory] = useState("");
    const [productName, setProductName] = useState("");
    const [isTotal, setTotal] = useState(20);
    const [resourceIndex, setResourceIndex] = useState(-1);
    const [isCollection, setCollection] = useState(20);

    const breakPoints = [
        { width: 1, itemsToShow: 1 },
        { width: 550, itemsToShow: 2 },
        { width: 768, itemsToShow: 3 },
        { width: 1200, itemsToShow: 4 }
    ];

    useEffect(() => {
        setCategory(window.localStorage.getItem('category'));
        setProductName(window.localStorage.getItem('product_name'));
    })

    const total_products = useQuery(GET_TOTAL_PRODUCTS);
    const total_collections = useQuery(GET_TOTAL_COLLECTIONS);

    useEffect(() => {
        if (total_products.data) {
            setTotal(total_products.data.products.meta.pagination.total);
            setCollection(total_collections?.data?.collections?.meta.pagination.total);
        }
    })

    const { loading, error, data } = useQuery(GET_CATEGORIES, { pollInterval: 300000, variables: { totalProducts: isTotal } });

    const { data: relate_data } = useQuery(GET_COLLECTIONS_RELATE, { pollInterval: 300000, variables: { totalCollections: isCollection, Category: category, Collection: productName } })

    let data1 = {};

    if (loading) return <CircularProgressCustom />;

    if (error)
        return (
            <>
                <h1>Sorry... We have some error</h1>
            </>
        );

    if (data) {
        data.categories.data.map((item, key) => {
            if (item?.attributes?.name === category) {
                item?.attributes?.collections.data.map((product, key1) => {
                    if (product?.attributes?.name === productName) {
                        data1 = product
                    }
                })
            }
        })
    }

    const handleRelateProducts = (product) => {
        setProductName(product);
        window.localStorage.setItem("product_name", product);
        window.location.reload(false);
    }

    const handleResource = (index) => {
        if (index == resourceIndex)
            setResourceIndex(-1);
        else
            setResourceIndex(index);
    }

    const mobile_ccts_str = data1?.attributes?.Specifications_CCTs;
    let mobile_ccts_arr = [];
    if (mobile_ccts_str) {
        const arr = mobile_ccts_str.split('/');
        for (let i = 0; i < arr.length; i++) {
            const last = mobile_ccts_arr[mobile_ccts_arr.length - 1];
            if (!last || last.length === 2) {
                mobile_ccts_arr.push([arr[i]]);
            } else {
                last.push(arr[i]);
            }
        };
    }


    return (
        Object.keys(data1).length !== 0 && <div>
            <div className='products-details mobile-hide'>
                <Container>
                    <Breadcrumb className='breadcrumb-customize mt-5 mb-5'>
                        <Breadcrumb.Item>home</Breadcrumb.Item>
                        <Breadcrumb.Item>products</Breadcrumb.Item>
                        <Breadcrumb.Item>{category}</Breadcrumb.Item>
                        <Breadcrumb.Item>{productName}</Breadcrumb.Item>
                    </Breadcrumb>
                    <div className='prodcut-detail row'>
                        <div className='product-detail-images col-md-6'>
                            <img src={apiUrl + data1?.attributes?.image.data?.attributes?.url} alt={data1?.attributes?.image.data?.attributes?.name} width="100%" style={{ objectFit: "contain" }} />
                        </div>
                        <div className='product-detail-contents pl-5 col-md-6'>
                            <div className='product-detail-contents-description'>
                                <h1>{data1?.attributes?.Small_Description_Title}</h1>
                                <p>{data1?.attributes?.Small_Description}</p>
                            </div>
                            <div className='product-detail-contents-specification'>
                                <h5>SPECIFICATIONS</h5>
                                <div className='specification-items mt-2'>
                                    {(data1?.attributes?.Specifications_Output_Title && data1?.attributes?.Specifications_Output) && <div className='specification-item row'>
                                        <div className='col-md-1'><img src={output} alt="output" /></div>
                                        <p className='col-md-2'>{data1?.attributes?.Specifications_Output_Title}</p>
                                        <span className='col-md-9'>{data1?.attributes?.Specifications_Output}</span>
                                    </div>}
                                    {(data1?.attributes?.Specifications_Efficacy_Title && data1?.attributes?.Specifications_Efficacy) && <div className='specification-item row'>
                                        <div className='col-md-1'><img src={efficacy} alt="efficacy" /></div>
                                        <p className='col-md-2'>{data1?.attributes?.Specifications_Efficacy_Title}</p>
                                        <span className='col-md-9'>{data1?.attributes?.Specifications_Efficacy}</span>
                                    </div>
                                    }
                                    {(data1?.attributes?.Specifications_CCTs_Title && data1?.attributes?.Specifications_CCTs) && <div className='specification-item row'>
                                        <div className='col-md-1'><img src={ccts} alt="ccts" /></div>
                                        <p className='col-md-2'>{data1?.attributes?.Specifications_CCTs_Title}</p>
                                        <span className='col-md-9'>{data1?.attributes?.Specifications_CCTs}</span>
                                    </div>}
                                    {data1?.attributes?.Specifications_operating_temperature && <div className='specification-item row'>
                                        <div className='col-md-1'><img src={temperature} alt="temperature" /></div>
                                        <span className='col-md-9'>{data1?.attributes?.Specifications_operating_temperature}</span>
                                    </div>}
                                    {data1?.attributes?.Specifications_warranty && <div className='specification-item row'>
                                        <div className='col-md-1'><img src={warranty} alt="warranty" /></div>
                                        <span className='col-md-9'>{data1?.attributes?.Specifications_warranty}</span>
                                    </div>}
                                </div>
                            </div>
                            <div className='product-detail-contents-btn'>
                                <button className='mt-4 learn-about-us-btn'>REQUEST QUOTE <BsArrowRight style={{ marginLeft: "20px" }} /></button>
                            </div>
                        </div>
                    </div>
                    <Tabs defaultActiveKey="resource" id="uncontrolled-tab-example" className='product-detail-tab mt-5'>
                        <Tab eventKey="resource" title="Resources & Downloads" tabClassName="profile-tabitem">
                            <div className="profile-tab-space">
                                <Resource />
                            </div>
                        </Tab>
                        <Tab eventKey="guide" title="Ordering Guide" tabClassName="profile-tabitem">
                            <div className="profile-tab-space">
                                <OrderGuide />
                            </div>
                        </Tab>
                        <Tab eventKey="distribution" title="Distribution" tabClassName="profile-tabitem">
                            <div className="profile-tab-space">
                                <Distribution />
                            </div>
                        </Tab>
                        <Tab eventKey="certification" title="Certifications" tabClassName="profile-tabitem">
                            <div className="profile-tab-space">
                                <Certifications />
                            </div>
                        </Tab>
                        <Tab eventKey="accessories" title="Accessories" tabClassName="profile-tabitem">
                            <div className="profile-tab-space">
                                <Accessories spec={data1?.attributes?.spec_pdf?.data} />
                            </div>
                        </Tab>
                    </Tabs>
                </Container>
                <div className='galley-application'>
                    <Container>
                        <h2>Gallery & Applications</h2>
                        {/* <img src={slider} alt="slider" style={{ width: "100%" }} className="mt-5"></img> */}
                        <div className="mt-5 d-flex flex-row"></div>
                        {data1.attributes?.Gallery_and_Applications?.data?.map((image_src, key) => (
                            <img src={apiUrl + image_src?.attributes?.url} alt={image_src?.attributes?.name} height="500px" />
                        ))}
                    </Container>
                </div>
                <Container>
                    <div className='product-description'>
                        <h2>{data1?.attributes?.Long_Description_Title}</h2>
                        {data1?.attributes?.Long_Description.indexOf("\n\n") && (
                            <Row className='mt-5 mb-4'>
                                {data1?.attributes?.Long_Description.split('\n\n')[0] && <Col>
                                    <p>
                                        {data1?.attributes?.Long_Description.split('\n\n')[0]}
                                    </p>
                                </Col>}
                                {data1?.attributes?.Long_Description.split('\n\n')[1] && <Col>
                                    <p>
                                        {data1?.attributes?.Long_Description.split('\n\n')[1]}
                                    </p>
                                </Col>}
                            </Row>
                        )}

                        <span>{data1?.attributes?.Description_Details_Title}</span>
                        <ul className='mt-3'>
                            {data1?.attributes?.Description_Details.split("\n") && (
                                data1?.attributes?.Description_Details.split("\n").map((item, key) => {
                                    return <li key={key}>{item.slice(1)}</li>
                                })
                            )}
                        </ul>
                        <Row className='mt-5'>
                            <Col md={6} className="family-contents">
                                <h3>{data1?.attributes?.About_Family_Title}</h3>
                                <p>{data1?.attributes?.About_Family}</p>
                            </Col>
                            <Col md={6}>
                                <img src={apiUrl + data1?.attributes?.About_Family_Image.data?.attributes?.url} alt="family" style={{ width: "100%", height: "248px" }}></img>
                            </Col>
                        </Row>
                    </div>
                </Container>
                <div className='new-products' id='new_products'>
                    <h2 className='new-products-title'>Related Products</h2>
                    <Container className='new-products-slide mt-5'>
                        <Carousel breakPoints={breakPoints}>
                            {relate_data?.collections?.data?.map((item, index) => {
                                return (
                                    <div className="product-slide" key={index} onClick={() => handleRelateProducts(item?.attributes?.name)}>
                                        <img alt="100%x280" src={apiUrl + item?.attributes?.image?.data?.attributes?.url} className="new-product-image" />
                                        <div className="card-body mt-3">
                                            <h4 className="card-title">{item?.attributes?.name}</h4>
                                            <p className="card-text mt-3">{category}</p>
                                            {/* <p className="card-text">{item.attributes.lumen_output}</p> */}
                                        </div>
                                    </div>
                                )
                            }
                            )}
                        </Carousel>
                    </Container>
                    <a className='view-all-products-btn' onClick={() => navigate('/products')}><div>VIEW ALL PRODUCTS <BsArrowRight style={{ marginLeft: "20px" }} /></div></a>
                </div>
            </div>
            <div className='products-details mobile-show'>
                <Container>
                    <Breadcrumb className='breadcrumb-customize mt-5 mb-5'>
                        <Breadcrumb.Item>home</Breadcrumb.Item>
                        <Breadcrumb.Item>products</Breadcrumb.Item>
                        <Breadcrumb.Item>{category}</Breadcrumb.Item>
                        <Breadcrumb.Item>{productName}</Breadcrumb.Item>
                    </Breadcrumb>
                    <div className='prodcut-detail row'>
                        <div className='product-detail-images col-md-6'>
                            <img src={apiUrl + data1?.attributes?.image.data?.attributes?.url} alt={data1?.attributes?.image.data?.attributes?.name} width="100%" style={{ objectFit: "contain" }} />
                        </div>
                        <div className='product-detail-contents pl-5 col-md-6'>
                            <div className='product-detail-contents-description'>
                                <h1>{data1?.attributes?.Small_Description_Title}</h1>
                                <p>{data1?.attributes?.Small_Description}</p>
                            </div>
                            <div className='product-detail-contents-specification'>
                                <h5>SPECIFICATIONS</h5>
                                <div className='specification-items mt-2'>
                                    {(data1?.attributes?.Specifications_Output_Title && data1?.attributes?.Specifications_Output) && <div className='specification-item row'>
                                        <div className='col-md-1'><img src={output} alt="output" /></div>
                                        <p className='col-md-2'>{data1?.attributes?.Specifications_Output_Title}</p>
                                        <span className='col-md-9'>{data1?.attributes?.Specifications_Output}</span>
                                    </div>}
                                    {(data1?.attributes?.Specifications_Efficacy_Title && data1?.attributes?.Specifications_Efficacy) && <div className='specification-item row'>
                                        <div className='col-md-1'><img src={efficacy} alt="efficacy" /></div>
                                        <p className='col-md-2'>{data1?.attributes?.Specifications_Efficacy_Title}</p>
                                        <span className='col-md-9'>{data1?.attributes?.Specifications_Efficacy}</span>
                                    </div>
                                    }
                                    {(data1?.attributes?.Specifications_CCTs_Title && data1?.attributes?.Specifications_CCTs) && <div className='specification-item row align-items-start'>
                                        <div className='col-md-1'><img src={ccts} alt="ccts" /></div>
                                        <p className='col-md-2'>{data1?.attributes?.Specifications_CCTs_Title}</p>
                                        <div className='d-flex flex-column'>
                                            {
                                                mobile_ccts_arr &&
                                                mobile_ccts_arr.map((ccts_sub_arr) => (
                                                    <span className='col-md-9'>{`${ccts_sub_arr[0]} ${ccts_sub_arr.length > 1 ? " / " + ccts_sub_arr[1] : ''}`}</span>
                                                ))
                                            }
                                        </div>

                                    </div>}
                                    {data1?.attributes?.Specifications_operating_temperature && <div className='specification-item row'>
                                        <div className='col-md-1'><img src={temperature} alt="temperature" /></div>
                                        <span className='col-md-9'>{data1?.attributes?.Specifications_operating_temperature}</span>
                                    </div>}
                                    {data1?.attributes?.Specifications_warranty && <div className='specification-item row'>
                                        <div className='col-md-1'><img src={warranty} alt="warranty" /></div>
                                        <span className='col-md-9'>{data1?.attributes?.Specifications_warranty}</span>
                                    </div>}
                                </div>
                            </div>
                            <div className='product-detail-contents-btn'>
                                <button className='mt-4 learn-about-us-btn'>REQUEST QUOTE <BsArrowRight style={{ marginLeft: "20px" }} /></button>
                            </div>
                        </div>
                    </div>
                    <div defaultActiveKey="resource" id="uncontrolled-tab-example" className='product-detail-tab mt-5'>
                        {
                            Tab_List.map((tabTitle, tabIndex) => (
                                <div>
                                    <div className='d-flex flex-row justify-content-between align-items-center pl-3 pr-3 mobile-tab' onClick={() => handleResource(tabIndex)}>
                                        <p>{tabTitle}</p>
                                        <img src={menudots} alt='menudots' width="20px" height="20px" />
                                    </div>
                                    {
                                        resourceIndex == 0 && resourceIndex == tabIndex &&
                                        <Resource />
                                    }
                                    {/* {
                                        resourceIndex == 1 && resourceIndex == tabIndex &&
                                        <OrderGuide />
                                    } */}
                                    {
                                        resourceIndex == 1 && resourceIndex == tabIndex &&
                                        <Distribution />
                                    }
                                    {
                                        resourceIndex == 2 && resourceIndex == tabIndex &&
                                        <Certifications />
                                    }
                                    {
                                        resourceIndex == 3 && resourceIndex == tabIndex &&
                                        <Accessories />
                                    }
                                </div>
                            ))
                        }
                    </div>
                </Container>
                <div className='galley-application'>
                    <Container>
                        <h2>Gallery & Applications</h2>
                        {/* <img src={slider} alt="slider" style={{ width: "100%" }} className="mt-5"></img> */}
                        <div className="mt-5 d-flex flex-row"></div>
                        {data1.attributes?.Gallery_and_Applications?.data?.map((image_src, key) => (
                            <img src={apiUrl + image_src?.attributes?.url} alt={image_src?.attributes?.name} height="500px" />
                        ))}
                    </Container>
                </div>
                <Container>
                    <div className='product-description'>
                        <h2>{data1?.attributes?.Long_Description_Title}</h2>
                        {data1?.attributes?.Long_Description.indexOf("\n\n") && (
                            <div className='row mt-5 mb-4'>
                                {data1?.attributes?.Long_Description.split('\n\n')[0] && <div className='col-md-6'>
                                    <p>
                                        {data1?.attributes?.Long_Description.split('\n\n')[0]}
                                    </p>
                                </div>}
                                {data1?.attributes?.Long_Description.split('\n\n')[1] && <div className='col-md-6'>
                                    <p>
                                        {data1?.attributes?.Long_Description.split('\n\n')[1]}
                                    </p>
                                </div>}
                            </div>
                        )}

                        <span>{data1?.attributes?.Description_Details_Title}</span>
                        <ul className='mt-3'>
                            {data1?.attributes?.Description_Details.split("\n") && (
                                data1?.attributes?.Description_Details.split("\n").map((item, key) => {
                                    return <li key={key}>{item.slice(1)}</li>
                                })
                            )}
                        </ul>
                        <Row className='mt-5'>
                            <Col md={6} className="family-contents">
                                <h3>{data1?.attributes?.About_Family_Title}</h3>
                                <p>{data1?.attributes?.About_Family}</p>
                            </Col>
                            <Col md={6}>
                                <img src={apiUrl + data1?.attributes?.About_Family_Image.data?.attributes?.url} alt="family" style={{ width: "100%", height: "248px" }}></img>
                            </Col>
                        </Row>
                    </div>
                </Container>
                <div className='new-products' id='new_products'>
                    <h2 className='new-products-title'>Related Products</h2>
                    <Container className='new-products-slide mt-5'>
                        <Carousel breakPoints={breakPoints}>
                            {relate_data?.collections?.data?.map((item, index) => {
                                return (
                                    <div className="product-slide" key={index} onClick={() => handleRelateProducts(item?.attributes?.name)}>
                                        <img alt="100%x280" src={apiUrl + item?.attributes?.image?.data?.attributes?.url} className="new-product-image" />
                                        <div className="card-body mt-3">
                                            <h4 className="card-title">{item?.attributes?.name}</h4>
                                            <p className="card-text mt-3">{category}</p>
                                            {/* <p className="card-text">{item.attributes.lumen_output}</p> */}
                                        </div>
                                    </div>
                                )
                            }
                            )}
                        </Carousel>
                    </Container>
                    <a className='view-all-products-btn' onClick={() => navigate('/products')}><div>VIEW ALL PRODUCTS <BsArrowRight style={{ marginLeft: "20px" }} /></div></a>
                </div>
            </div>
        </div>
    )
}

export default ProductDetail;